import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";

const empty = { nameTR: "", nameEN: "", descriptionTR: "", descriptionEN: "", icon: "utensils", image: "", slug: "", sortOrder: 0, isActive: true, isFeatured: false };

const Categories = () => {
  const [list, setList] = useState([]);
  const [editing, setEditing] = useState(null);
  const [showForm, setShowForm] = useState(false);

  const load = () => api.get("/categories").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      if (editing.id) {
        await api.put(`/categories/${editing.id}`, editing);
        toast.success("Kategori güncellendi");
      } else {
        await api.post("/categories", editing);
        toast.success("Kategori eklendi");
      }
      setShowForm(false); setEditing(null); load();
    } catch (e) {
      toast.error("Hata: " + (e?.response?.data?.detail || ""));
    }
  };

  const del = async (id) => {
    if (!window.confirm("Bu kategori ve tüm ürünleri silinecek. Emin misiniz?")) return;
    await api.delete(`/categories/${id}`);
    toast.success("Silindi"); load();
  };

  return (
    <div className="space-y-6" data-testid="categories-page">
      <header className="flex items-end justify-between">
        <div>
          <h1 className="font-serif text-3xl text-zbeach-dark">Kategoriler</h1>
          <p className="text-zbeach-muted text-sm mt-1">Menü kategorilerini yönetin.</p>
        </div>
        <button onClick={() => { setEditing({ ...empty, sortOrder: list.length }); setShowForm(true); }}
          className="px-4 py-2.5 rounded-full bg-zbeach-turquoise text-white font-medium text-sm btn-glow" data-testid="cat-add-btn">
          <i className="fa-solid fa-plus mr-1" /> Yeni Kategori
        </button>
      </header>

      <div className="bg-zbeach-surface border border-zbeach-gold/15 rounded-2xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-zbeach-bg text-zbeach-muted uppercase text-xs tracking-wider">
            <tr><th className="text-left p-3">Sıra</th><th className="text-left p-3">Ad (TR)</th><th className="text-left p-3">Ad (EN)</th><th className="text-left p-3">Slug</th><th className="text-left p-3">Durum</th><th className="text-right p-3">İşlem</th></tr>
          </thead>
          <tbody>
            {list.map((c) => (
              <tr key={c.id} className="border-t border-zbeach-gold/10" data-testid={`cat-row-${c.id}`}>
                <td className="p-3">{c.sortOrder}</td>
                <td className="p-3 font-medium">{c.nameTR}</td>
                <td className="p-3 text-zbeach-muted">{c.nameEN}</td>
                <td className="p-3 text-xs text-zbeach-muted">{c.slug}</td>
                <td className="p-3">{c.isActive ? <span className="text-xs px-2 py-0.5 rounded-full bg-green-100 text-green-700">Aktif</span> : <span className="text-xs px-2 py-0.5 rounded-full bg-zbeach-muted/15 text-zbeach-muted">Pasif</span>}</td>
                <td className="p-3 text-right space-x-2">
                  <button onClick={() => { setEditing(c); setShowForm(true); }} className="text-zbeach-turquoise hover:underline text-xs" data-testid={`cat-edit-${c.id}`}>Düzenle</button>
                  <button onClick={() => del(c.id)} className="text-red-600 hover:underline text-xs" data-testid={`cat-delete-${c.id}`}>Sil</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showForm && editing && (
        <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" onClick={() => setShowForm(false)}>
          <form onSubmit={save} onClick={(e) => e.stopPropagation()} className="bg-zbeach-surface rounded-3xl p-6 w-full max-w-lg max-h-[90vh] overflow-y-auto" data-testid="cat-form">
            <h2 className="font-serif text-2xl mb-4">{editing.id ? "Kategori Düzenle" : "Yeni Kategori"}</h2>
            <div className="grid grid-cols-2 gap-3">
              <Field label="Ad TR *" value={editing.nameTR} onChange={(v) => setEditing({ ...editing, nameTR: v })} required testid="cat-nameTR" />
              <Field label="Ad EN" value={editing.nameEN} onChange={(v) => setEditing({ ...editing, nameEN: v })} testid="cat-nameEN" />
              <Field label="Açıklama TR" value={editing.descriptionTR} onChange={(v) => setEditing({ ...editing, descriptionTR: v })} />
              <Field label="Açıklama EN" value={editing.descriptionEN} onChange={(v) => setEditing({ ...editing, descriptionEN: v })} />
              <Field label="Icon (FA isim)" value={editing.icon} onChange={(v) => setEditing({ ...editing, icon: v })} placeholder="utensils" />
              <Field label="Sıra" type="number" value={editing.sortOrder} onChange={(v) => setEditing({ ...editing, sortOrder: parseInt(v) || 0 })} />
            </div>
            <Field label="Görsel URL" value={editing.image} onChange={(v) => setEditing({ ...editing, image: v })} />
            <Field label="Slug (boş bırak otomatik üretsin)" value={editing.slug} onChange={(v) => setEditing({ ...editing, slug: v })} />
            <div className="flex gap-4 mt-2">
              <Checkbox label="Aktif" checked={editing.isActive} onChange={(v) => setEditing({ ...editing, isActive: v })} />
              <Checkbox label="Öne çıkar" checked={editing.isFeatured} onChange={(v) => setEditing({ ...editing, isFeatured: v })} />
            </div>
            <div className="flex justify-end gap-2 mt-5">
              <button type="button" onClick={() => setShowForm(false)} className="px-4 py-2 rounded-full bg-zbeach-bg text-zbeach-muted text-sm">İptal</button>
              <button type="submit" className="px-5 py-2 rounded-full bg-zbeach-turquoise text-white text-sm font-medium" data-testid="cat-save">Kaydet</button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export const Field = ({ label, value, onChange, type = "text", placeholder = "", required, testid }) => (
  <div className="col-span-1">
    <label className="block text-xs uppercase tracking-wider text-zbeach-muted mb-1">{label}</label>
    <input type={type} value={value ?? ""} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} required={required}
      data-testid={testid}
      className="w-full px-3 py-2 rounded-lg bg-zbeach-bg border border-zbeach-gold/20 focus:outline-none focus:border-zbeach-turquoise text-sm" />
  </div>
);

export const Checkbox = ({ label, checked, onChange }) => (
  <label className="flex items-center gap-2 text-sm cursor-pointer">
    <input type="checkbox" checked={!!checked} onChange={(e) => onChange(e.target.checked)} className="w-4 h-4 accent-zbeach-turquoise" />
    {label}
  </label>
);

export default Categories;
